module.exports = __webpack_public_path__ + "static/img/294_TO8_1695_og.0e99387.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/294_TO8_1695_og.jpg
// module id = ncCJ
// module chunks = 0